import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-notfound',
  templateUrl: './page-notfound.component.html',
  styleUrls: ['./page-notfound.component.scss']
})
export class PageNotfoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.location.href = 'https://aggne.com';
  }

}
